import { OrganizationStatus } from './types'

export const ORGANIZATION_STATUS_OPTIONS = [
    { value: OrganizationStatus.ACTIVE, label: 'Aktivna' },
    { value: OrganizationStatus.INACTIVE, label: 'Neaktivna' },
    { value: OrganizationStatus.ARCHIVED, label: 'Arhivirana' },
] as const
